import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { initiateFetchWorkflow } from '../actions/SearchActions';
import SearchOptions from '../entities/SearchOptions';
import useImageSearchOptionsFromLocation from '../hooks/useImageSearchOptionsFromLocation';
import {
  calculateAppliedFilterNums,
  imageSearchContentTypeToKeys,
} from '../utils/searchUtils';
import ImageMenuContainer from './ImageMenuContainer';
import {
  ImageSelectedSearchFilterOptions,
  SelectedSearchFilterOptions,
} from './MenuContainerInterfaces';
import SearchContainer from './SearchContainer';
import GraphicAppliedFilters from './appliedFilters/GraphicAppliedFilters';

const ImageSearchContainer = (): JSX.Element => {
  const searchOptions = useImageSearchOptionsFromLocation();

  const searchOptionsRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchOptionsRef.current) {
      dispatch(initiateFetchWorkflow(searchOptions));
    }
    searchOptionsRef.current = searchOptions;
  }, [searchOptions]);

  const getFilterTotal = (
    selectedSearchFilterOptions: SelectedSearchFilterOptions<ImageSelectedSearchFilterOptions>
  ) => {
    return calculateAppliedFilterNums(
      selectedSearchFilterOptions,
      imageSearchContentTypeToKeys,
      SearchOptions.getDefaultSearchOptions()
    );
  };

  return (
    <SearchContainer
      renderAppliedFilters={() => <GraphicAppliedFilters />}
      menuContainer={ImageMenuContainer}
      calculateAppliedFilterNums={getFilterTotal}
    />
  );
};

export default ImageSearchContainer;
